import { Injectable } from '@angular/core';
import { EncrDecrService } from './encr-decr.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private encrDecr: EncrDecrService) {}

  isMobile() {
    var ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    )
      return true;
    else return false;
  }

  getScreenWidth() {
    return window.screen.availWidth;
  }

  findPathDataFormatted(obj: any, item: any, objName: string) {
    var path = this.findPathData(obj, item); // first let's get path array to item (if it exsits)
    if (!path) {
      // if it does't exits
      return ''; // return something to signal its inexistance
    }
    // console.log(obj,item,objName,path);

    return objName + ['["'] + path.join('"]["') + '"]'; // otherwise format the path array into a string and return it
  }

  findPathData(obj: any, item: any): any {
    // Object.keys(obj).forEach((key) => {
    for (var key in obj) {
      // for each key in obj is either an object or an array
      if (obj[key] && typeof obj[key] === 'object') {
        // if the current property (value of obj[key]) is also an object/array
        var result = this.findPathData(obj[key], item); // try finding item in that object
        if (result) {
          // if we find it
          result.unshift(key); // we shift the current key to the path array (result will be an array of keys)
          return result; // and we return it to our caller
        }
      } else if (obj[key] === item) {
        // otherwise (if obj[key] is not an object or array) we check if it is the item we're looking for
        return [key]; // if it is then we return the path array (this is where the path array constructed)
      }
    }
  }

  setLocalStorage(name: string, data: any): void {
    let dataEncr = this.encrDecr.set(JSON.stringify(data));
    localStorage.setItem(
      name,
      environment.production ? dataEncr : JSON.stringify(data)
    );
  }

  getLocalStorage(name: string): any {
    let dataFromLS = localStorage.getItem(name);
    return dataFromLS === null
      ? null
      : JSON.parse(
          environment.production
            ? this.encrDecr.get(localStorage.getItem(name))
            : localStorage.getItem(name) || '{}'
        );
  }
}
